














import { Component, Prop, Vue } from 'vue-property-decorator'

import CrossSellProductAddedDialog from '@plugin/Common/components/cross-sell/CrossSellProductAddedDialog.vue'
import { CrossSellProductInterface } from '@plugin/Common/interfaces/cross-sell/entities/cross-sell-product.interface'
import { crossSellService } from '@plugin/Common/services/cross-sell/api/cross-sell.service'
import { localStorageService } from '@plugin/Common/services/cross-sell/local-storage.service'

const defaultProductModel: CrossSellProductInterface = {
  description: '',
  id: 0,
  imageUrl: '',
  name: '',
  price: 0,
  priceLabel: '',
  url: '',
}

const defaultSettingsModel: any = {
  CountCrossSellLightboxShouldShow: 0,
  IsCrossSellLightboxEnabled: false,
}

@Component({
  components: {
    CrossSellProductAddedDialog,
  },
})
export default class CrossSellAddedToCartComponent extends Vue {
  @Prop({ type: String })
  public cancelButtonLabel!: string

  @Prop({ required: true })
  public productId!: number

  @Prop({ type: String })
  public title!: string

  public apiError: Error | null = null

  public apiIsLoading = false

  public product: CrossSellProductInterface = { ...defaultProductModel }

  public records: CrossSellProductInterface[] = []

  public settings: any = { ...defaultSettingsModel }

  async mounted() {
    await this.retrieveRecords()
  }

  get showDialog(): boolean {
    const apiIsResolved = !this.apiIsLoading && !this.apiError
    const settingsCheckPass =
      this.settings.IsCrossSellLightboxEnabled &&
      this.settings.CountCrossSellLightboxShouldShow > 0 &&
      this.settings.CountCrossSellLightboxShouldShow >= localStorageService.getProductViewCount(this.productId)
    const hasRecords = this.records.length > 0

    return apiIsResolved && settingsCheckPass && hasRecords
  }

  public resetState(): void {
    this.apiError = null
    this.apiIsLoading = false
    this.product = { ...defaultProductModel }
    this.records = []
    this.settings = { ...defaultSettingsModel }
  }

  public async retrieveRecords(): Promise<void> {
    this.apiIsLoading = true
    try {
      this.settings = await crossSellService.getSettingsForProduct(this.productId)
      localStorageService.updateProductViewCount(
        this.productId,
        localStorageService.getProductViewCount(this.productId) + 1
      )

      const response = await crossSellService.getRecordsForProduct(this.productId)
      this.product = response.product
      this.records = response.records
    } catch (err) {
      // TODO: Address this tech debt by adding proper type checking
      // @ts-expect-error Untyped error handling
      this.apiError = err
    }
    this.apiIsLoading = false
  }
}
